import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-105" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-106" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-107" data-mp="1cgb8le7dgifo">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-ink uppercase" data-id="element-108" data-mp="2a1ytb1ugtcbd">
            Frequently Asked <span className="text-forest" data-id="element-109" data-mp="252m4wcny3x6o">Questions</span>
          </h2>
        </div>
        <div className="space-y-4" data-id="element-110" data-mp="203suit3ygmaq">
          {faqs.map((faq, index) => <div key={faq.q} className={`bg-white border rounded-xl overflow-hidden transition-colors duration-150 ease-out ${openIndex === index ? 'border-forest/40' : 'border-line'}`} data-id="element-111" data-mp="205vsbzbcnjq0" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-mist transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-112" data-mp="jp1d1b8ckzg7">
                <span className="font-bold text-lg text-ink pr-8" data-id="element-113" data-mp="1fqq94x4wtx6k">{faq.q}</span>
                <ChevronDown className={`text-forest transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-114" data-mp="11vxppnlwfwup" />
              </button>
              <AnimatePresence initial={false} data-id="element-115" data-mp="wxw4ox4wxngl">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-116" data-mp="iymrm6c079gu">
                    <div className="px-6 pb-5 text-graphite border-t border-line pt-4 space-y-2" data-id="element-117" data-mp="2kuc3qqe3k460">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-118" data-mp="2ay0opsn4h07v">{paragraph}</p>)}
                      {faq.list && <ul className="list-disc pl-5 grid sm:grid-cols-2 gap-x-4 gap-y-1" data-id="element-119" data-mp="38lrbwzsk1fp6">
                          {faq.list.map(item => <li key={item} data-id="element-120" data-mp="33kbnqyv2yt2k">{item}</li>)}
                        </ul>}
                      {faq.afterList && <p data-id="element-121" data-mp="2umhslr91y5gz">{faq.afterList}</p>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}